import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import useStyles from 'isomorphic-style-loader/useStyles';
import App from 'modules/App';
import Modal from 'components/Modal';
import { CONSENT_MODAL } from 'modules/Mobile/constants';
import { useAction } from 'hooks';
import PDFSubpageWrapper from 'components/PDFSubpageWrapper';
import styles from './MobileConsentModal.pcss';
const MobileConsentModal = ()=>{
    useStyles(styles);
    const staticFilesDir = useSelector(App.selectors.staticFilesDir);
    const openModalId = useSelector(App.selectors.modal);
    const closeModal = useAction(App.actions.closeModal);
    const onCloseModal = ()=>{
        closeModal();
    };
    return /*#__PURE__*/ _jsx(Modal, {
        modalId: CONSENT_MODAL,
        openModalId: openModalId,
        styleModifier: "md",
        onClose: onCloseModal,
        contentCustomClass: styles.mobileConsentContent,
        children: /*#__PURE__*/ _jsx(PDFSubpageWrapper, {
            module: staticFilesDir
        })
    });
};
export default MobileConsentModal;
